import {
  Dialog,
  DialogContent,
  DialogTitle,
  ListItemText,
  FormControl,
  TextField,
  Select,
  Checkbox,
  InputLabel,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
  clearTrainingPlan,
  createTrainingPlanModal,
  createUserTPModal,
} from "../../../context/FormacionDesarollo/TrainingPlansActions";
import Add from "../../../assets/svg/addPrestacion.svg";
import "../css/ModalCreateTrainingPlan.css";
import TrainingPlansContext from "../../../context/FormacionDesarollo/TrainingPlansContext";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import DateRangeFieldSV from "../../MyMood/Fields/DateRangeFieldSV";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  CREATE_TRAININGPLAN,
  GET_ALL_PROJECT,
  GET_ALL_TRAININGPLANS,
  GET_AVAILABLE_COURSES,
  GET_USERS_BY_PROJECT,
} from "../../../Querys/querys";
import { ErrorAlert } from "../../../alerts/errorAlert";

import * as Yup from "yup";
import { addDays, format, isEqual, parseISO, subMonths } from "date-fns";
import AdminColaboradoresTrainingPlan from "./AdminColaboradoresTrainingPlan";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
const CreateTrainingPlan = ({ _ }: any) => {
  // console.log("crear plan de capacitacion");
  const { state, dispatch } = useContext(TrainingPlansContext);
  const [initialValuesForm, setInitialValuesForm] = useState({
    title: "",
    description: "",
    area: "",
    cursos: "",
  });
  const [stateCalendario, setStateCalendario] = useState([
    {
      startDate: subMonths(new Date(), 0),
      endDate: addDays(new Date(), 0),
      key: "selection",
    },
  ]);
  const [btnDisable, setBtnDisable] = useState<boolean>(false);

  const [startDate] = useState(subMonths(new Date(), 0).toString());
  const [endDate] = useState(addDays(new Date(), 0).toString());

  const [selectedAllProjects, setSelectedAllProjects] = useState<String[]>([]);
  const [selectedAllCourses, setSelectedAllCourses] = useState<String[]>([]);
  const [usersByCampusProject, setUsersByCampusProject] = useState<Array<any>>(
    []
  );

  const [counterTxt, setCounterTxt] = useState(0);

  const [projects, setProjects] = useState<Array<any>>([]);
  const [cursos, setCursos] = useState<Array<any>>([]);

  const { data: resultProject } = useQuery(GET_ALL_PROJECT);
  const allProject = resultProject?.GET_ALL_PROJECT;
  const [getUserByProject] = useLazyQuery(GET_USERS_BY_PROJECT);

  const {
    data: availableCourses,
    loading,
    startPolling,
    stopPolling,
  } = useQuery(GET_AVAILABLE_COURSES);
  const allAvailableCourses = availableCourses?.GET_AVAILABLE_COURSES;

  const [selectedUser, setSelectedUser] = useState<String[]>([]);

  const validationSchema = () => {
    return {
      title: Yup.string().required(
        "El nombre del plan de capacitación es requerido"
      ),
      area: Yup.array()
        .required("Obligatorio")
        .test(
          "area",
          "Es necesario seleccionar una área o proyecto",
          function (value) {
            if (value === undefined || value.length === 0) {
              return false;
            } else {
              return true;
            }
          }
        ),
      cursos: Yup.array()
        .required("Obligatorio")
        .test("cursos", "Es necesario seleccionar un curso", function (value) {
          if (value === undefined || value.length === 0) {
            return false;
          } else {
            return true;
          }
        }),
    };
  };

  const [createNewTrainingPlan] = useMutation(CREATE_TRAININGPLAN, {
    refetchQueries: [{ query: GET_ALL_TRAININGPLANS }],
  });

  const formik = useFormik({
    initialValues: initialValuesForm,
    validationSchema: Yup.object(validationSchema()),
    onSubmit: async (formData, { resetForm }) => {
      if (selectedUser.length === 0) {
        ErrorAlert({
          text: "Es necesario agregar usuarios al plan de capacitación",
        });
        return;
      }
      let arrayUserSel: any = [];
      let objUserSel: {};
      selectedUser.map((selUser: any) => {
        objUserSel = { id: selUser.id };
        arrayUserSel.push(objUserSel);
      });
      const initDate: any = format(stateCalendario[0].startDate, "yyyy-MM-dd");
      const endDate: any = format(stateCalendario[0].endDate, "yyyy-MM-dd");
      const dateEqual = isEqual(parseISO(initDate), parseISO(endDate));
      if (dateEqual) {
        ErrorAlert({ text: "Necesita seleccionar un rango de fechas" });
        return;
      }
      const trainingData = {
        title: formData.title,
        description: formData.description,
        dateInit: initDate,
        dateEnd: endDate,
        area: selectedAllProjects,
        cursos: selectedAllCourses,
        usuarios: arrayUserSel,
      };
      console.log("Información del plan de capacitación: ", trainingData);
      try {
        setBtnDisable(true);
        let { data } = await createNewTrainingPlan({
          variables: {
            input: trainingData,
          },
        });
        SuccessfulAlert({
          text: "Registro creado con éxito",
        });
        setBtnDisable(false);
        closeModalCreateTraingPlan();
      } catch (error) {
        ErrorAlert({
          text: "Ocurrió un error al crear el plan de capacitación",
        });
        console.log(error);
        setBtnDisable(false);
      }
    },
  });

  const counterCaracter = (e: any) => {
    setCounterTxt(e.length);
  };

  const onChangeProject = (e: any) => {
    if (e.target.value.indexOf("Todas") > -1) {
      if (projects.length === selectedAllProjects.length) {
        setSelectedAllProjects([]);
      } else {
        let filtered = projects.map((item: any) => item.proyectNameAndClient);
        setSelectedAllProjects(filtered);
      }
    } else {
      setSelectedAllProjects(e.target.value);
    }
  };

  const onChangeCursos = (e: any) => {
    if (e.target.value.indexOf("Todos") > -1) {
      if (cursos.length === selectedAllCourses.length) {
        setSelectedAllCourses([]);
      } else {
        let filtered = cursos.map((item: any) => item.title);
        setSelectedAllCourses(filtered);
      }
    } else {
      setSelectedAllCourses(e.target.value);
    }
  };

  const handleAdminColaborador = async () => {
    console.log("Area seleccionada: ", selectedAllProjects);
    if (selectedAllProjects.length === 0) {
      ErrorAlert({ text: "Seleccione el Area" });
      return;
    } else {
      setUsersByCampusProject([]);
      const proyectsName = selectedAllProjects.map((name: any) => {
        const nameSplit = name.split("/");
        return nameSplit[0];
      });
      console.log("array de proyectos: ", proyectsName);
      let { data } = await getUserByProject({
        variables: {
          input: {
            projects: proyectsName,
          },
        },
      });
      console.log("valor de data: ", data);
      if (data.GET_USERS_BY_PROJECT.length > 0) {
        setUsersByCampusProject(data.GET_USERS_BY_PROJECT);
        createUserTPModal(state._id, true, dispatch);
      } else {
        ErrorAlert({
          text: "No hay claboradores con los valores seleccionados",
        });
      }
    }
  };

  const closeModalCreateTraingPlan = () => {
    clearTrainingPlan(false, dispatch);
    setCounterTxt(0);
    setSelectedAllCourses([]);
    setSelectedAllProjects([]);
    setSelectedUser([]);
    formik.resetForm();
  };
  useEffect(() => {
    startPolling(1000);
    return () => {
      stopPolling();
    };
  }, [startPolling, stopPolling]);
  useEffect(() => {
    if (allProject) {
      setProjects(allProject);
    }
    if (allAvailableCourses) {
      setCursos(allAvailableCourses);
    }
  }, [allAvailableCourses, allProject]);
  return (
    <>
      <Dialog
        open={state.createModalTrainingPlan}
        aria-labelledby="form-dialog-title"
        className="dialogTrainingPlan"
        fullWidth={true}
      >
        <IconButton
          aria-label="close"
          onClick={() => {
            clearTrainingPlan(false, dispatch);
            closeModalCreateTraingPlan();
          }}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Form onSubmit={formik.handleSubmit}>
            <DialogTitle className="titleCreateTrainingPlan">
              <span className="titleCreateTrainingPlan">
                Crear plan de Capacitación
              </span>
            </DialogTitle>
            <DialogContent className="nameTrainingPlan">
              <TextField
                label="Nombre del plan de capacitación *"
                name="title"
                inputProps={{ maxLength: 50 }}
                variant="outlined"
                className="nameTrainingPlan"
                size="small"
                value={formik.values.title}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                onKeyPress={(e) => {
                  e.key === "Enter" && e.preventDefault();
                }}
                error={formik.touched.title && Boolean(formik.errors.title)}
                helperText={formik.touched.title && formik.errors.title}
              />
            </DialogContent>
            <DialogContent>
              <DateRangeFieldSV
                setDate={setStateCalendario}
                containerClass={"dateBorder"}
                daySelected1={startDate}
                daySelected2={endDate}
                nameLabel={"Periodo"}
              />
            </DialogContent>
            <DialogContent className="twoSelect">
              <FormControl
                className="selectCourses"
                size="small"
                variant="outlined"
                error={formik.touched.cursos && Boolean(formik.errors.cursos)}
              >
                <InputLabel
                  id="demo-simple-select-label"
                  style={{
                    backgroundColor: "#FFFFFF",
                    // width: "124px",
                  }}
                >
                  Seleccionar Cursos *
                </InputLabel>
                <Select
                  style={{
                    fontFamily: "Roboto",
                    fontStyle: "italic",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    // width: "212px",
                    // height: "40px",
                  }}
                  value={selectedAllCourses}
                  onChange={(e) => {
                    formik.handleChange(e);
                    onChangeCursos(e);
                  }}
                  labelId="demo-simple-select-label"
                  id="cursos"
                  name="cursos"
                  multiple
                  renderValue={(selected: any) => selected.join(",")}
                  error={formik.touched.cursos && Boolean(formik.errors.cursos)}
                >
                  <MenuItem key={0} value={"Todos"}>
                    <Checkbox
                      checked={selectedAllCourses.length === cursos.length}
                      style={{ color: "#FABB00" }}
                    />
                    <ListItemText primary={"Todos"} />
                  </MenuItem>
                  {cursos.map((curso: any) => (
                    <MenuItem key={curso.id} value={curso.title}>
                      <Checkbox
                        checked={selectedAllCourses.indexOf(curso.title) > -1}
                        style={{ color: "#FABB00" }}
                      />
                      <ListItemText primary={curso.title} />
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText style={{ color: "red", marginLeft: "0px" }}>
                  {formik.touched.cursos && formik.errors.cursos}
                </FormHelperText>
              </FormControl>
              <FormControl
                size="small"
                variant="outlined"
                className="selectArea"
                error={formik.touched.area && Boolean(formik.errors.area)}
              >
                <InputLabel
                  id="demo-simple-select-label"
                  style={{ backgroundColor: "white", zIndex: 0 }}
                >
                  &Aacute;rea o Proyecto*
                </InputLabel>
                <Select
                  style={{
                    fontFamily: "Roboto",
                    fontStyle: "italic",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                  value={selectedAllProjects}
                  onChange={(e) => {
                    formik.handleChange(e);
                    onChangeProject(e);
                  }}
                  label={"Área o Proyecto"}
                  labelId="demo-simple-select-label"
                  id="area"
                  name="area"
                  multiple
                  renderValue={(selected: any) => selected.join(",")}
                  error={formik.touched.area && Boolean(formik.errors.area)}
                >
                  <MenuItem key={0} value={"Todas"}>
                    <Checkbox
                      checked={selectedAllProjects.length === projects.length}
                      style={{
                        color: "#FABB00",
                      }}
                    />
                    <ListItemText primary={"Todas"} />
                  </MenuItem>
                  {projects.map((project: any) => (
                    <MenuItem
                      key={project.id}
                      value={project.proyectNameAndClient}
                    >
                      <Checkbox
                        checked={
                          selectedAllProjects.indexOf(
                            project.proyectNameAndClient
                          ) > -1
                        }
                        style={{
                          color: "#FABB00",
                        }}
                      />
                      <ListItemText primary={project.proyectNameAndClient} />
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText
                  style={{
                    color: "red",
                    marginLeft: "0px",
                  }}
                >
                  {formik.touched.area && formik.errors.area}
                </FormHelperText>
              </FormControl>
            </DialogContent>
            <DialogContent className="oneComponent">
              <button
                className="btnAdminColaboradorTrainingPlan"
                type="button"
                onClick={() => handleAdminColaborador()}
              >{`Administrar colaboradores(${
                selectedUser.length > 0 ? selectedUser.length : 0
              })`}</button>
            </DialogContent>
            <DialogContent className="inputDescription">
              <TextField
                id="outlined-multiline-static"
                label="Descripción del plan de capacitación"
                multiline
                name="description"
                className="inputDescription"
                rows={4}
                variant="outlined"
                inputProps={{ maxLength: 300 }}
                value={formik.values.description}
                onChange={(e: any) => {
                  formik.handleChange(e);
                  counterCaracter(e.target.value);
                }}
                onBlur={formik.handleBlur}
                InputLabelProps={{
                  style: { zIndex: 0 },
                }}
                onKeyPress={(e) => {
                  e.key === "Enter" && e.preventDefault();
                }}
                error={
                  formik.touched.description &&
                  Boolean(formik.errors.description)
                }
                helperText={
                  formik.touched.description && formik.errors.description
                }
              />
              <div className="divCounterCaracter">
                <label className="txtConterDesc">{`${counterTxt}/300`} </label>
              </div>
            </DialogContent>
            <DialogContent className="twoBtnsTrainingPlan">
              <div className="containerButtons">
                <div className="containerCancelTrainingPlan">
                  <button
                    className="btnCancelarTrainingPlan"
                    type="button"
                    onClick={() => {
                      closeModalCreateTraingPlan();
                    }}
                  >
                    Cancelar
                  </button>
                </div>
                <div className="containerAddTrainingPlan">
                  <button
                    className="btnAddTrainingPlan"
                    type="submit"
                    disabled={btnDisable}
                  >
                    <div className="infoBtnAddTrainingPlan">
                      <div>
                        <img
                          className="imgBtnAdd"
                          src={Add}
                          alt="Crear Plan de Capacitacion"
                        />
                      </div>
                      <div>
                        <span className="txtBtnAdd">
                          Crear plan de capacitaci&oacute;n
                        </span>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </DialogContent>
          </Form>
        </DialogContent>
      </Dialog>
      {usersByCampusProject.length > 0 ? (
        <AdminColaboradoresTrainingPlan
          users={usersByCampusProject}
          userSelect={selectedUser}
          setSelectedUser={setSelectedUser}
          colaboradoresBD={[]}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default CreateTrainingPlan;
